module.exports = __webpack_public_path__ + "static/img/telephone.30d2b98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/telephone.png
// module id = ZTdy
// module chunks = 10